import { commissionService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'
import { CommissionConversionType } from '@/constants'

const initialStates = {
    status: 'LOADING',
    commissionsList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setCommissionsList(state, commissions) {
        state.status       = 'SET_LIST'
        state.commissionsList = commissions
    },
    setPagination(state, pagination) {
        state.status     = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
            page: 1
        }
    },
    createCommission(state, commission) {
        state.status = 'CREATE'
        state.commissionsList = Object.assign({[commission.id]: commission}, state.commissionsList)
    },
    updateCommission(state, commission) {
        state.status = 'UPDATE'
        state.commissionsList[commission.id] = Object.assign({}, state.commissionsList[commission.id], commission)
    },
    deleteCommission(state, id) {
        state.status = 'DELETE_FROM_LIST'
        delete state.commissionsList[id]
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    status: state   => state.status,
    commissions: state => state.commissionsList,
    selectableCommissions: (state, getters) => {
        return Object.keys(getters.commissions).map((id) => {
            return {
                value: id,
                label: getters.commissions[id].name,
            }
        })
    },
    commissionById: state => id => state.commissionsList[id],
    params: state => state.params,
    pagination: state => state.pagination,
    hasCPCCommission: (state, getters) => {
        return Object.keys(getters.commissions).filter(
            id => getters.commissions[id].conversion_type === CommissionConversionType.CPC
        ).length > 0
    },
    hasDefaultCommission: (state, getters) => {
        return Object.keys(getters.commissions).filter(
            id => getters.commissions[id].name === 'default'
        ).length > 0
    }
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    resetParams({commit}) {
        commit('resetParams')
    },
    fetch({commit, state}, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            commissionService.fetch(params)
                .then(response => {
                    const result = response.data
                    const commissions = groupByArrayOfObject(result.data, 'id')

                    commit('setCommissionsList', commissions)
                    if (params.no_paginate) {
                        commit('setPagination', {
                            no_paginate: true
                        })
                    } else {
                        commit('setPagination', {
                            per_page: result.per_page,
                            current_page: result.current_page,
                            last_page: result.last_page,
                            no_paginate: false,
                        })
                        commit('setParams', {
                            page: result.current_page,
                        })
                    }
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error)
                })
        })
    },
    find({commit}, id) {
        commit('loading')

        return new Promise((resolve, reject) => {
            commissionService.find(id)
                .then((response) => {
                    const result = response.data
                    const commission = result.data
                    let commissions = {}
                    commissions[commission.id] = commission

                    commit('setCommissionsList', commissions)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error)
                })
        })
    },
    create({commit}, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            commissionService.create(params)
                .then(response => {
                    const result = response.data

                    commit('createCommission', result.data)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error)
                })
        })
    },
    edit({commit}, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            commissionService.edit(params, params.id)
                .then(() => {
                    commit('updateCommission', params)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error)
                })
        })
    },
    // customizedCommissions({commit}, params) {
    //     commit('loading')

    //     return new Promise((resolve, reject) => {
    //         commissionService.customizedFetch(params.publisher_id)
    //             .then(response => {
    //                 const result = response.data
    //                 const commissions = groupByArrayOfObject(result.data, 'id')

    //                 commit('setCommissionsList', commissions)
    //                 resolve(result)
    //             })
    //             .catch(error => {
    //                 commit('error')
    //                 reject(error.response ? error.response.data : error)
    //             })
    //     })
    // },
    // setCustomizeCommissions({}, params) {
    //     return new Promise((resolve, reject) => {
    //         commissionService.setCustomizeCommissions(params)
    //             .then(response => {
    //                 resolve(response ? response.data : {})
    //             })
    //             .catch(error => {
    //                 reject(error.response ? error.response.data : error)
    //             })
    //     })
    // }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}